import { z } from 'zod';
import { ErrorResponseSchema } from './errors';
// Maximum number of images allowed for style templates
export const MAX_STYLE_TEMPLATE_IMAGES = 8;
export const StyleTemplateSchema = z.object({
    id: z.string(),
    title: z.string(),
    description: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    deleted_at: z.string().nullable(),
});
// Schema for style template with image URLs (for frontend display)
export const StyleTemplateWithUrlsSchema = StyleTemplateSchema.extend({
    imageUrls: z.array(z.string()).default([]),
});
export const StyleTemplatesResponseSchema = z.object({
    type: z.literal('success'),
    data: z.array(StyleTemplateWithUrlsSchema),
});
export const StyleTemplateResponseSchema = z.object({
    type: z.literal('success'),
    data: StyleTemplateSchema,
});
// Union type for style templates API responses
export const StyleTemplatesApiResponseSchema = z.discriminatedUnion('type', [
    StyleTemplatesResponseSchema,
    ErrorResponseSchema,
]);
export const StyleTemplateApiResponseSchema = z.discriminatedUnion('type', [
    StyleTemplateResponseSchema,
    ErrorResponseSchema,
]);
// ===== CREATE STYLE TEMPLATE SCHEMAS =====
export const CreateStyleTemplateRequestSchema = z.object({
    title: z.string().min(1, 'Title is required'),
    description: z.string().min(1, 'Description is required'),
    images: z
        .array(z.string())
        .max(MAX_STYLE_TEMPLATE_IMAGES, `Maximum ${MAX_STYLE_TEMPLATE_IMAGES} images allowed`)
        .optional(),
});
export const CreateStyleTemplateSuccessResponseSchema = z.object({
    type: z.literal('success'),
    data: z.object({
        message: z.string(),
        styleTemplate: StyleTemplateSchema,
    }),
});
export const CreateStyleTemplateResponseSchema = z.discriminatedUnion('type', [
    CreateStyleTemplateSuccessResponseSchema,
    ErrorResponseSchema,
]);
